import EquipmentGroup from './equipment-group';
import PointGroup from './point-group';
import EquipmentTypeTree from './equipment-type-tree';
import ECM from './ecm';
import Equipment from './equipment';

export default [{
    path: 'dcim',
    component: () => import('@/views/dcim'),
    children: [
        ...EquipmentGroup,
        ...PointGroup,
        ...EquipmentTypeTree,
        ...ECM,
        ...Equipment,
    ]
}]
